<template>
  <div class="tips">
    <div class="sss" v-html="textinfo"></div>
    <div class="box">
      <div :class="{ cen: true, active: !flag }" @click="change"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mytips",
  data() {
    return {
      flag: true,
      textinfo: this.$t("a532"),
    }
  },
  methods: {
    change() {
      this.flag = this.flag == true ? false : true;
      this.textinfo = this.flag == true ? this.$t("a532") : this.$t("a533");
    }
  },
};
</script>

<style lang="less" scoped>
.tips {
  position: fixed !important;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  display: none;
  .sss {
    padding: 10px;
  }
  .box {
    position: absolute;
    width: 30px;
    height: 20px;
    top: -20px;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .cen {
      width: 20px;
      height: 11px;
      margin: 5px auto 0;
      background: url("../../assets/img/arrow_bottom.png") no-repeat;
      background-size: 100%;
      &.active {
        background: url("../../assets/img/arrow_upp.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Mytips/tips.vue